/**
 * Placeholder tenant list.
 *
 * Story 0.5 replaces this with the real thing: options restricted to the user's
 * `{clientes}` list, `idCliente` in the URL, persisted across the session, and part
 * of every TanStack Query key (BR-19).
 *
 * The two entries are NOT invented — they are the tenants drawn in shot `2n`,
 * including the note on each. Using the handoff's own placeholder data keeps this
 * file honest until the real list arrives.
 */
export interface ClienteStub {
  idCliente: string
  nome: string
  observacao: string
}

export const CLIENTES_STUB: ClienteStub[] = [
  {
    idCliente: 'tribunal-de-justica',
    nome: 'Tribunal de Justiça (exemplo)',
    observacao: 'dados segregados por cliente',
  },
  {
    idCliente: 'orgao-b',
    nome: 'IOX (teste)',
    observacao: 'segmento sem exigência de conformidade',
  },
]

export const CLIENTE_PADRAO = CLIENTES_STUB[0]!.idCliente
